module.exports = __webpack_public_path__ + "static/media/BrownTS_2016_Manuscript_TSQL_STUFF_HowTo.5f99313e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/manuscript/BrownTS_2016_Manuscript_TSQL_STUFF_HowTo.pdf
// module id = 356
// module chunks = 0